<template>
    <span>
        <div class="nctouch-tag-nav" id="nctouchTagNav">
            <ul>
                <li><a href="javascript:void(0);" @click="chooseAllNav()"><span>{{navTitle}}</span><i></i></a><i class="choice-top-i" :style="isColor?choiceTopIP:false"></i></li>
              <div class="package-nav-inner"  v-show="isShow">
                <li :class="{selected:currentEvalLv== 'all'}" @click="bindSetEvalLv('all')"><a href="javascript:void(0);" data-name="全部評論"><span>သုံးသပ္ခ်က္အားလုံး </span><i>({{evaluateGoodsTotal}})</i></a></li>
                <li :class="{selected:currentEvalLv== '1'}" @click="bindSetEvalLv('1')"><a href="javascript:void(0);"  data-name="好評"><span>ေကာင္း </span><i>({{evaluateCount[1]}})</i></a></li>
                <li :class="{selected:currentEvalLv== '2'}" @click="bindSetEvalLv('2')"><a href="javascript:void(0);"  data-name="中評"><span>သင့္ </span><i>({{evaluateCount[2]}})</i></a></li>
                <li :class="{selected:currentEvalLv== '3'}" @click="bindSetEvalLv('3')"><a href="javascript:void(0);"  data-name="差評"><span>ညံ့ </span><i>({{evaluateCount[3]}})</i></a></li>
                <li :class="{selected:currentEvalLv== '4'}" @click="bindSetEvalLv('4')"><a href="javascript:void(0);"  data-name="曬圖"><span>Show </span><i>({{evaluateCount[4]}})</i></a></li>
              </div>
            </ul>
        </div>
      <div class="nctouch-full-mask-bg" v-show="isMask" @click="isMask=false,isShow=false"></div>
        <div class="product-eval-list" :style="{height: showHeight+ 'px'}" id="productEvalList" style="overflow:hidden; position:relative">
            <ul v-if="evaluateGoodsVoList.length">
                <li v-for="evalItem in evaluateGoodsVoList">
                    <div class="eval-user">
                        <div class="user-avatar"><img :src="evalItem.memberHeadUrl" /></div>
                        <span class="user-name">{{evalItem.memberName}}</span>
                        <time>{{evalItem.evaluateTimeStr|$convertDate}}</time>
                    </div>
                    <div class="goods-raty"><i :class="getStarClass(evalItem.scores)"></i></div>
                    <dl class="eval-con">
                        <dt>{{evalItem.evaluateContent1}}</dt>
                        <dd class="goods_geval" v-if="evalItem.image1FullList && evalItem.image1FullList.length">
                            <a href="javascript:void(0);" v-for="(itemImage , indexImage) in evalItem.image1FullList" @click="bindShowBigImage(evalItem.evaluateId , 1 , indexImage)">
                                <img :src="itemImage|$convertImage(240,240)" />
                            </a>
                        </dd>
                    </dl>
                  <!-- 评论 解释 -->
                    <div class="eval-explain" v-if="evalItem.explainContent1">
                        {{evalItem.explainContent1}}
                    </div>
                  <!--会员追评-->
                    <span v-if="evalItem.evaluateContent2">
                        <div class="again-eval" data-name="追加评价"><time>{{evalItem.evaluateAgainTimeStr|$convertDate}}</time></div>
                        <dl class="eval-con">
                            <dt>{{evalItem.evaluateContent2}}</dt>
                            <dd class="goods_geval" v-if="evalItem.image2FullList && evalItem.image2FullList.length">
                                <a href="javascript:void(0);" v-for="(image2Item,indexImage2) in evalItem.image2FullList" @click="bindShowBigImage(evalItem.evaluateId , 2 , indexImage2)">
                                    <img :src="image2Item|$convertImage(240,240)"/>
                                </a>
                            </dd>

                        </dl>
                        <div class="eval-explain" v-if="evalItem.explainContent2">解释：{{evalItem.explainContent2}}</div>
                    </span>
                  <!-- full sku -->
                    <div class="eval-specifications" v-if="evalItem.goodsFullSpecs">{{evalItem.goodsFullSpecs}}</div>
                </li>

              <!--<li class="loading"><div class="spinner"><i></i></div>数据读取中</li>-->
            </ul>
            <div v-if="!evaluateGoodsVoList.length" class="no-data-bg">
                <div class="no-data">
                    <div class="no-img order"></div>
                    <p data-name="亲，该商品没有相应的评价哦~">ဤပစၥည္းမွာတူညီေသာသံုးသပ္ခ်က္မရွိဘူးေနာ္~</p>
                </div>
            </div>
        </div>
      <!-- 移动到body -->
        <div :class="['nctouch-bigimg-layout', {hide:!showLayer}]" ref="layer"  @touchmove="">
            <div class="close" @click="bindHideBigImage()" ></div>
            <div class="pic-box" ref="evalSwipe">
                <ul>
                    <li v-for="itemImage in currentImageList"
                        :style="{'background-image': 'url('+ itemImage +')'}"></li>
                </ul>
            </div>
            <div class="nctouch-bigimg-turn">
                <ul>
                    <li :class="{cur:( index-1) == showBigImageEvalIndex}"
                        v-for="index in currentImageList.length"></li>
                </ul>
            </div>
        </div>
    </span>
</template>
<script>
  //    var ApiUrl = "https://my.zegobird.com:11101/api";

  // js 区域
  var urlEva = ApiUrl + '/goods/evaluate/queryGoodsEvaluate',
    detailIscrollInstance ,
    swipteInstance
  ;

  export default {
    //外部传入参数
    props: {
      // 必传且是字符串
      commonId: {
        type: Number,
        required: true
      },
      evaluateGoodsTotal : {
        type: Number,
        required: true
      },
      evaluateCount : {},
      height:{
        type:Number ,
        defalut: 667
      },
    },
    /*
     * 自身数据,一定要一个function
     */
    data:function() {
      return {
        navTitle:'သုံးသပ္ခ်က္အားလုံး',
        //评论列表
        evaluateGoodsVoList:[],
        //显示评论大图
        showBigImageEvalId: 0,
        showBigImageEvalIndex: 0,
        //
        showBigImageEvalType: 1,
        //显示弹出层
        showLayer: false ,
        //当前页号
        currentPage:1,
        //1好评 2中评 3差评 4有图 all全部
        currentEvalLv : 'all',
        //页面
        pageEntity: {
          hasMore: true,
          totalPage: 1
        } ,
        loadingData : false,
        isShow : false,
        isMask:false,
        isColor:false,
        choiceTopIP:{transform:'rotate(180deg)'},
      }
    },
    /**
     * 计算属性
     */
    computed: {
      showHeight:function(){
        return this.height
      },
      currentImageList: function () {
        var _id = this.showBigImageEvalId,
          _type = this.showBigImageEvalType,
          _index = this.showBigImageEvalIndex ,
          _result = []

        ;

        this.evaluateGoodsVoList.forEach(function (item) {
          if (item.evaluateId == _id) {
            _result =  item["image" + _type + "FullList"]
          }
        })
        return _result;
      }
    },
    /**
     * 过滤器
     */
    mounted() {

      var $layer = this.$refs.layer;
      var $body = document.getElementsByTagName("body")[0];
      $body.appendChild($layer);
      this.loadEval()
    },
    /**
     * 自定义方法
     */
    methods: {
      //去除无关的touch事件
      excludeTouch:function(event){
        event.preventDefault();
        return false ;
      },

      //小星星的样式
      getStarClass: function (value) {
        return "star" + value
      },
      //加载评论
      loadEval:function(){

        var self =  this ;
        if (!this.pageEntity.hasMore || this.loadingData){
          return
        }
        this.loadingData = true;
        $.get(urlEva , {
          page:self.currentPage ,
          evalLv:self.currentEvalLv,
          commonId :self.commonId
        },function(xhr){
          var str = JSON.stringify(xhr);
          var my = Rabbit.uni2zg(str);
          xhr = JSON.parse(my);
          if(xhr.code ==200 ){
            self.evaluateGoodsVoList = self.evaluateGoodsVoList.concat(xhr.datas.evaluateGoodsVoList)
            self.currentPage ++ ;
            self.pageEntity = xhr.datas.pageEntity
            self.loadingData = false ;
            self.$nextTick(function () {
              self.refreshIscroll()
            })
          }
        })
      },
      refreshIscroll :function(){
        var self = this ;
        if (!self.scrollInstance) {
          detailIscrollInstance = new IScroll("#productEvalList", {
            scrollX: false,
            scrollY: true,
            click: false
          });
          detailIscrollInstance.on("scrollEnd",function(){
            if(detailIscrollInstance.maxScrollY === detailIscrollInstance.y){
              self.loadEval();
            }
          })
        } else {
                self.scrollInstance.refresh();
        }
        // if (detailIscrollInstance){
        //   detailIscrollInstance.refresh()
        // }else{
        //   detailIscrollInstance = new IScroll("#productEvalList", {
        //     scrollX: false,
        //     scrollY: true,
        //     click: false
        //   });
        //   detailIscrollInstance.on("isBottom",function(){
        //     self.loadEval()
        //   })
        // }
      },
      //觸發點擊ALL菜單打開關閉
      menuAction:function(){
        this.isShow =! this.isShow;
        this.isMask =! this.isMask;
        this.isColor =! this.isColor;
      },
      submenuAction:function(){
        this.isShow =false;
        this.isMask =false;
        this.isColor =false;
      },
      chooseAllNav:function(){
        this.menuAction()
      },
      //点击获取不同评论的类型
      bindSetEvalLv:function(evalLvString,){
        this.currentPage = 1 ;
        this.currentEvalLv = evalLvString;
        this.evaluateGoodsVoList = [] ;
        this.pageEntity={
          hasMore: true,
          totalPage: 1
        };
        switch (evalLvString){
          case "1":this.navTitle='ေကာင္း ';break;
          case "2":this.navTitle="သင့္ ";break;
          case "3":this.navTitle="ညံ့ ";break;
          case "4":this.navTitle="Show";break;
          default:this.navTitle="သုံးသပ္ခ်က္အားလုံး "
        }
        this.loadEval()
        this.submenuAction()
      },
      //点击显示大图
      bindShowBigImage: function (evaluateId, type, index) {

        var self = this
        this.showBigImageEvalId = evaluateId
        this.showBigImageEvalType = type
        this.showBigImageEvalIndex = index
        this.showLayer = true
        this.$nextTick(function () {


          swipteInstance = Swipe(self.$refs.evalSwipe, {
            startSlide: index,
            continuous: false,
            stopPropagation: true,
            disableScroll:true ,
            callback: function (sIndex, element) {
              self.showBigImageEvalIndex = sIndex
            }
          });

        })
      },
      //点击隐藏大图
      bindHideBigImage: function () {

        this.showBigImageEvalId = 0
        this.showBigImageEvalType = 1
        this.showBigImageEvalIndex = 0
        swipteInstance && swipteInstance.kill()
        this.showLayer = false
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/goods-eval-all/goods-eval-all.vue